export default __webpack_public_path__ + "static/media/back.c0a7145e.png";